<script>
    export let tooltipText = "";
</script>

<a
    href="#"
    data-toggle="tooltip"
    title={tooltipText}
    style="color:#ccc; margin-left:5px;"
>
    <i class="fas fa-question-circle" />
</a>